import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.47 20.5037C2.93 20.5037 1.97 18.8337 2.74 17.5037L10.27 4.49375C11.04 3.16375 12.96 3.16375 13.73 4.49375L21.26 17.5037C22.03 18.8337 21.07 20.5037 19.53 20.5037H4.47ZM19.53 18.5037L12 5.49375L4.47 18.5037H19.53ZM11 10.5037V12.5037C11 13.0537 11.45 13.5037 12 13.5037C12.55 13.5037 13 13.0537 13 12.5037V10.5037C13 9.95375 12.55 9.50375 12 9.50375C11.45 9.50375 11 9.95375 11 10.5037ZM13 17.5037V15.5037H11V17.5037H13Z",
		fill: "currentColor"
	})
});
export default SvgWarningOutline;
